const TIMEZONE_SUFFIX = /(?:Z|[+-]\d{2}(?::?\d{2})?)$/i;

export const parseApiDateTime = (value: string): Date => {
  const normalizedValue = value
    .trim()
    .replace(' ', 'T')
    .replace(/([+-]\d{2})$/, '$1:00');
  const timestamp = TIMEZONE_SUFFIX.test(normalizedValue) ? normalizedValue : `${normalizedValue}Z`;
  return new Date(timestamp);
};

export const formatApiDateTime = (value: string): string => {
  const date = parseApiDateTime(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString();
};

export const formatApiDateTimeInTimeZone = (value: string, timeZone: string): string => {
  const date = parseApiDateTime(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('ru-RU', { timeZone });
};
